// base-page.component.ts
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ContentAnalyticsService } from '@app/services/content-analytics.service';

@Component({
  template: '',
})
export class BasePageComponent implements OnInit, OnDestroy {
  protected pageStartTime: number;
  protected contentType: string;
  protected contentId: string;
  protected contentName: string;

  constructor(protected contentAnalytics: ContentAnalyticsService) {}

  ngOnInit() {
    this.pageStartTime = Date.now();
  }

  ngOnDestroy() {
    // Only track engagement time if content is being viewed
    if (this.contentType && this.contentId && this.contentName) {
      const timeSpentSeconds = Math.round((Date.now() - this.pageStartTime) / 1000);

      // Only log if time spent is reasonable (e.g., not navigation glitches)
      if (timeSpentSeconds >= 2) {
        this.contentAnalytics.trackEngagementTime(
          this.contentType,
          this.contentId,
          this.contentName,
          timeSpentSeconds
        );
      }
    }
  }

  // Child components can call this to set the content being viewed
  protected setViewedContent(type: string, id: string, name: string) {
    this.contentType = type;
    this.contentId = id;
    this.contentName = name;
  }
}
